const EnvEnum = Object.assign({
  LOCAL: { name: 'local', url: 'http://localhost:8080' },
  STAGING: { name: 'staging', url: 'https://dev.admin.exporo.de' },
  PROD: { name: 'production', url: 'https://admin.exporo.de' },
});

Object.freeze(EnvEnum);

export default EnvEnum;



// WEBPACK FOOTER //
// ./src/enum/EnvEnum.js